// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2086 ? "479a7878" : chunkId) + "." + {"1467":"d65b6e840c0718ad","2086":"019d323d014f0d70"}[chunkId] + ".js";
};